import { useSyncExternalStore } from 'react';

const queries = { sm: '(min-width: 640px)', md: '(min-width: 768px)', lg: '(min-width: 1024px)', xl: '(min-width: 1280px)' } as const;
type Bp = keyof typeof queries;

function subscribe(cb: () => void) {
  const mqls = Object.values(queries).map((q) => window.matchMedia(q));
  mqls.forEach((m) => m.addEventListener('change', cb));
  return () => mqls.forEach((m) => m.removeEventListener('change', cb));
}

function snapshot() {
  let s = '';
  for (const k of Object.keys(queries) as Bp[]) s += window.matchMedia(queries[k]).matches ? '1' : '0';
  return s;
}

export function useBreakpoint() {
  const s = useSyncExternalStore(subscribe, snapshot, () => '1111');
  return { sm: s[0] === '1', md: s[1] === '1', lg: s[2] === '1', xl: s[3] === '1', isMobile: s[1] !== '1' };
}
